(() => {
  const initialize = (root) => {
    if (!root || root.dataset.lsInitialized === 'true') return;
    root.dataset.lsInitialized = 'true';

    const tabs = [...root.querySelectorAll('[data-ls-tab]')];
    const panels = [...root.querySelectorAll('[data-ls-panel]')];
    const activateTab = (tab, focus = false) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.lsPanel !== tab.dataset.lsTab;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activateTab(tabs[next], true);
      });
    });

    const copyButton = root.querySelector('[data-ls-copy-code]');
    const copyStatus = root.querySelector('[data-ls-code-status]');
    copyButton?.addEventListener('click', async () => {
      const code = copyButton.dataset.code || 'LSBOOH10';
      try {
        await navigator.clipboard.writeText(code);
        copyStatus.textContent = 'Copied';
      } catch (error) {
        copyStatus.textContent = `Code: ${code}`;
      }
      window.setTimeout(() => { copyStatus.textContent = 'Tap to copy'; }, 2200);
    });

    root.querySelector('[data-ls-replay]')?.addEventListener('click', () => {
      const astro = root.querySelector('.ls-astro');
      const ring = root.querySelector('.ls-landing-ring');
      if (!astro || !ring) return;
      astro.style.animation = 'none';
      ring.style.animation = 'none';
      void astro.offsetWidth;
      astro.style.animation = '';
      ring.style.animation = '';
    });

    const motionButton = root.querySelector('[data-ls-motion-toggle]');
    motionButton?.addEventListener('click', () => {
      const paused = root.classList.toggle('is-motion-paused');
      motionButton.setAttribute('aria-pressed', String(paused));
      motionButton.textContent = paused ? 'Play motion' : 'Pause motion';
    });

    const menuButton = root.querySelector('.ls-menu-toggle');
    const mobileMenu = root.querySelector('.ls-mobile-nav');
    const menuItems = mobileMenu ? [...mobileMenu.querySelectorAll('a')] : [];
    const closeMenu = (restoreFocus = false) => {
      if (!menuButton || !mobileMenu) return;
      menuButton.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('ls-menu-open');
      menuButton.textContent = 'Menu';
      if (restoreFocus) menuButton.focus();
    };
    menuButton?.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      if (isOpen) return closeMenu();
      menuButton.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileMenu.classList.add('is-open');
      document.body.classList.add('ls-menu-open');
      menuButton.textContent = 'Close';
      menuItems[0]?.focus();
    });
    menuItems.forEach((link) => link.addEventListener('click', () => closeMenu()));
    root.addEventListener('keydown', (event) => {
      if (!menuButton || menuButton.getAttribute('aria-expanded') !== 'true') return;
      if (event.key === 'Escape') closeMenu(true);
      if (event.key !== 'Tab' || !menuItems.length) return;
      const first = menuButton;
      const last = menuItems[menuItems.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14 });
      root.querySelectorAll('.ls-reveal').forEach((element) => observer.observe(element));
    } else {
      root.querySelectorAll('.ls-reveal').forEach((element) => element.classList.add('is-visible'));
    }
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-ls-home]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
